export const LANGUAGES = {
  EN: {
    name: 'EN',
    value: 'en',
  },
  PL: {
    name: 'PL',
    value: 'pl',
  },
  FR: {
    name: 'FR',
    value: 'fr',
  },
  /*
  SE: {
    name: 'SE',
    value: 'se',
  },
  DE: {
    name: 'DE',
    value: 'de',
  },
  RU: {
    name: 'RU',
    value: 'ru',
  },
  */
};

export const BLOG_LANGUAGES = {
  EN: {
    name: 'EN',
    value: 'en',
  },
  PL: {
    name: 'PL',
    value: 'pl',
  },
};

export const LANGUAGE_STORAGE_KEY = 'zonifero-language';
export const DEFAULT_LANGUAGE = LANGUAGES.EN.value;



// WEBPACK FOOTER //
// ./src/common/consts/languages.js